
import React from 'react'
import { useState, useRef} from "react";
import UploadIcon from '@mui/icons-material/Upload';
import LoadingButton from '@mui/lab/LoadingButton';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';

let Exif = require('exif-js');

export default function PhotoUploadDialog(props) {
    const inputRef = useRef(null);
    const [loading, setLoading] = React.useState(false);
    const [isDisabled,setIsDisabled] = useState(false);

    //プレビューの表示状態
    const [showPreview, setShowPreview] = useState(false);
    //プレビューに表示するデータ（URLとTitle）
    const [showDatas,setShowDatas] = useState([]);
    
    //file形式で保持
    const [files,setFiles] = useState([]);
    //タグの入力値
    const tagsRef = useRef(null);

    const handleDragOver = (e) =>{
        e.stopPropagation();
        e.preventDefault();
    };
    function handleDrop(e){
        e.stopPropagation();
        e.preventDefault();

        onFileInput(e.dataTransfer.files);
    };

    function DeleteItem(target){
        var list = showDatas.filter((item,index)=>index !== Number(target.currentTarget.value));
        var fileList = files.filter((item,index)=>index !== Number(target.currentTarget.value));
        setShowDatas(list);
        setFiles(fileList);

        setShowPreview(list.length !== 0);
    }

    function onFileInput(elements){
        setIsDisabled(true);
        let dataArr = [];
        let fs = [];
        [...elements].forEach(element=>{
            if(element.type === 'image/jpeg' || element.type === 'image/png'){
                if(!showDatas.some(item => item.name === element.name)){
                    dataArr.push({url:URL.createObjectURL(element),name:element.name});
                    fs.push(element);
                }
            }
        });
        setFiles(files.concat([...fs]));  //file形式で保持
        setShowDatas(showDatas.concat([...dataArr]));  //表示用データにセット
        setShowPreview(true);   //プレビューを表示
        
        setIsDisabled(false);
    }
    //[アップデート]ボタンクリック処理
    function onClickUpload(){
        setLoading(true);
        setIsDisabled(true);
        GetUpdateFile();
    }
    async function GetUpdateFile(){
        var promises = [];
        let datas = [];

        //平均計算用
        let latitude_avg = null;
        let latitude_cnt = 0;
        let longitude_avg = null;
        let longitude_cnt = 0;

        files.forEach(function(file){
            promises.push(new Promise( function(resolve){
                Exif.getData(file,async function(){
                    let get_DateTimeOriginal = Exif.getTag(this,"DateTimeOriginal");
                    let DateTimeOriginal;
                    if(get_DateTimeOriginal !== undefined){
                        var dt = get_DateTimeOriginal.split(' ');
                        
                        DateTimeOriginal = dt[0].replaceAll(":","/") +" " + dt[1];
                    }else{
                        DateTimeOriginal = null;
                    }
                    let get_GPSLatitude = Exif.getTag(this,"GPSLatitude");
                    let get_GPSLongitude = Exif.getTag(this,"GPSLongitude");
                    let title = file.name;
                    let date = new Date();
                    let uploadDateTime = date.getFullYear() + "/" + ("0"+(date.getMonth() + 1)).slice(-2) + "/" + ("0"+date.getDate()).slice(-2) + " " + ("0"+date.getHours()).slice(-2) + ":" + ("0"+date.getMinutes()).slice(-2) + ":" + ("0"+date.getSeconds()).slice(-2);
                    
                    //緯度経度の変換
                    let GPSLatitude = null;
                    if(get_GPSLatitude !== undefined){
                        GPSLatitude = get_GPSLatitude[0] + (get_GPSLatitude[1]/60) + (get_GPSLatitude[2]/3600);
                        GPSLatitude = Math.round(GPSLatitude * 1000000) / 1000000;   //桁の調整
                        if(GPSLatitude !== 0){
                            latitude_avg += GPSLatitude;    //平均計算用統計
                            latitude_cnt++;
                        }
                    }
                    let GPSLongitude = null;
                    if(get_GPSLongitude !== undefined){
                        GPSLongitude = get_GPSLongitude[0] + (get_GPSLongitude[1]/60) + (get_GPSLongitude[2]/3600);
                        GPSLongitude = Math.round(GPSLongitude * 1000000) / 1000000;   //桁の調整
                        if(GPSLatitude !== 0){
                            longitude_avg += GPSLongitude;   //平均計算用統計
                            longitude_cnt++;
                        }
                    }
                    let locationSettingFlg = GPSLatitude !== null && GPSLongitude !== null && GPSLatitude !== 0 && GPSLongitude !== 0;
                    let coordinates = locationSettingFlg ? [GPSLongitude,GPSLatitude] : null;
                    
                    let data = {
                        isRemoved:false,
                        type:"photo",
                        uploadDateTime:uploadDateTime,
                        filmingDateTime:DateTimeOriginal,
                        Location:{
                            type:"Point",
                            coordinates:coordinates
                        },
                        locationSettingFlg:locationSettingFlg,
                        Direction:{
                            pitch:0,
                            yaw:0,
                            roll:0
                        },
                        directionSettingFlg:false,
                        title:title,
                        originalDataLocation:{
                            type:"Point",
                            coordinates:coordinates
                        },
                        originalDataDirection:{
                            pitch:0,
                            yaw:0,
                            roll:0
                        },
                        Photo:[{
                            accessURL:null,
                            thumbnailURL:null
                        }]
                    };
                datas.push(data);
                resolve();
                });
            }));
        });

        await Promise.all(promises);

        //位置情報設定済み写真の有無
        if(latitude_cnt === 0 || longitude_cnt === 0){
            //位置情報不明のデータの無効値
            datas.forEach(data => {
                if(data.Location.coordinates === null){
                    data.Location.coordinates = [0,0];
                }
            });
        }else{
            latitude_avg = latitude_avg / latitude_cnt;
            longitude_avg = longitude_avg / longitude_cnt;
    
            //位置情報不明のデータの平均設定
            datas.forEach(data => {
                if(data.Location.coordinates === null){
                    longitude_avg = Math.round(longitude_avg * 1000000) / 1000000;   //桁の調整
                    latitude_avg = Math.round(latitude_avg * 1000000) / 1000000;   //桁の調整
                    data.Location.coordinates = [longitude_avg,latitude_avg];
                }
            });
        }
                
        await props.upload(files,datas,tagsRef.current.value);
        
    }

    return (
        <div>
            <div className="photoDialog" >
                <header style={{height:"20px",margin:"5px"}}>
                    <button
                        className="closeButton"
                        label="閉じる"
                        onClick={props.onBack}
                        disabled={loading}
                        >
                        <div className="closeButton_icon">
                            <span>✕</span>
                        </div>
                    </button>
                </header>
                <div style={{height:"calc(100% - 30px)",padding:"0 20px 20px 20px"}}>
                    {/* 写真アップロードエリア */}
                    <label style={{fontWeight:"bold"}}>写真のアップロード</label>
                    
                    <button
                            className="addButton"
                            label="ファイル追加"
                            onClick={()=>inputRef.current.click()}
                            disabled={loading}
                            >
                            <div className="addButton_icon">
                                <span>＋</span>
                            </div>
                    </button>
                    <div style={{position:"relative",height:"300px",width:"100%"}}>
                        <ul className="photoPreviewArea" 
                            onDragOver={!loading ? handleDragOver:null}
                            onDrop={(e)=>!loading ? handleDrop(e) :null}
                            onClick={()=>!showPreview ?? inputRef.current.onClick}
                            disabled={loading}
                            >
                            <input
                                ref={inputRef}
                                id="file"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                multiple
                                style={{display:"none"}}
                                onChange={(e)=>onFileInput(e.target.files)}
                                hidden
                            />
                            {showDatas.map((data,index) =>
                                <li className="photoPreviewItem" key={data + "_" + index}>
                                    <img className="photoPreviewItem_img" src={data.url} id={index} title={data.name} alt={data.name}/>
                                    <IconButton color="inherit" value={index} onClick={(event)=>DeleteItem(event)} sx={{position:"absolute",top:"-5px",right:"-5px",padding:"0"}}
                                        size='small'
                                        disabled={loading}>
                                        <CancelIcon />
                                    </IconButton>
                                    <label className="photoPreviewItem_label">{data.name}</label>
                                </li>
                            )}
                            {!showPreview && <label htmlFor="file"
                                className="filelabel"
                                >ドラッグ＆ドロップもしくはクリックで写真を追加（複数可）</label>
                            }
                        </ul>
                    </div>
                    
                    {/* タグエリア */}
                    <label style={{fontWeight:"bold",marginTop:"30px"}}>タグ　(観察対象の名称、災害名など)</label>
                    <div className="TagInputArea">
                        <textarea disabled={loading}
                            ref={tagsRef}
                            onBlur={()=>{
                                var text = tagsRef.current.value;
                                var new_text = text.replace(/\n/g, "");
                                if (new_text !== text) {
                                    // 元の値と置き換えた値が等しくなければ新しい値に置き換える
                                    tagsRef.current.value = new_text;
                            }}}/>
                    </div>
                    <label style={{fontWeight:"bold",color:"red",fontSize:"12px"}}>　※複数指定の場合、半角スペースで追加すること</label>
                    
                    <div style={{textAlign:"center",marginTop:"15px"}}>
                        <LoadingButton
                            onClick={()=>onClickUpload()}
                            endIcon={<UploadIcon />}
                            loading={loading}
                            loadingPosition="end"
                            variant="contained"
                            disabled={isDisabled || showDatas === null || showDatas.length < 1}
                        >
                            アップロード
                        </LoadingButton>
                    </div>
                </div>
            </div>
            <div className="Dialog-cover" style={!loading ? {display:"none"}:{}}></div>
        </div>
    );

}
